module.exports = __webpack_public_path__ + "img/marketing-primary-left.8f800d70.png";